import { connect } from 'react-redux';

import OutsideModal from '@/components/outside/OutsideModal';
import {
  _getOutside, _saveOutside, _updateOutsideInputValue, _removeOutside, _closeOutsideModal
} from '@/actions/outsideAction';

export default connect(
  state => ({
    startDate: state.outside.startDate,
    endDate: state.outside.endDate,
    stdDate: state.outside.stdDate,
    startHour: state.outside.startHour,
    startMinute: state.outside.startMinute,
    endHour: state.outside.endHour,
    endMinute: state.outside.endMinute,
    outsideList: state.outside.outsideList,
    desc: state.outside.desc,
    isOpen: state.outside.isOpenModal
  }),
  {
    _getOutside, _saveOutside, _updateOutsideInputValue, _removeOutside, _closeOutsideModal
  }
)(OutsideModal);


// WEBPACK FOOTER //
// ./src/containers/outside/OutsideModalContainer.js